import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from '../config/config';

@Injectable({
  providedIn: 'root',
})
export class MeterRepaymentService {
  private pathApi = this.config.setting['pathApi'] + 'meterRepayment/';

  constructor(private http: HttpClient, private config: AppConfig) {}

  public getAll(dataIn: any): Observable<any> {
    return this.http.post(`${this.pathApi}getAll`, dataIn, { observe: 'response' });
  }

  public save(dataIn: any): Observable<any> {
    return this.http.post(`${this.pathApi}save`, dataIn, { observe: 'response' });
  }

  public delete(id: number): Observable<any> {
    return this.http.delete(`${this.pathApi}delete/${id}`, { observe: 'response' });
  }

  public getVendorsForSelect(meterRepaymentId: number, utilityId: number): Observable<any> {
    return this.http.get(`${this.pathApi}getVendorsForSelect/${meterRepaymentId}/${utilityId}`, {
      observe: 'response',
    });
  }
}
